export default __webpack_public_path__ + "static/media/NYBG_Logo_Black_RGB.8a78bd5e.svg";